import React, {useRef} from 'react'
import Slider from "react-slick"
import WOW from 'react-wow'

import * as S from './styled'

const ProjectSlider = ({items}) => {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToScroll: 1,
        draggable: true,
        initialSlide: Math.floor(items.length / 2),
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 1
    };
    
    return (
        <S.ProjectSliderWrapper>
            <WOW animation="fadeIn" data-wow-delay="0.3s">
                <Slider ref={sliderRef} {...settings}>
                    {items.map((item, i) => (
                        <S.ProjectSliderItem key={i}>
                            <S.ProjectSliderItemImage src={item} />
                        </S.ProjectSliderItem>
                    ))}
                </Slider>
            </WOW>
        </S.ProjectSliderWrapper>
    )
}

export default ProjectSlider